import pb from '../lib/pocketbase';

export async function getTipos(page, perPage) {
  return await pb.collection('tipo').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false
  });
}

export async function createTipo(tipo) {
  return await pb.collection('tipo').create(tipo);
}

export async function updateTipo(id, tipo) {
  return await pb.collection('tipo').update(id, tipo);
}

export async function deleteTipo(id) {
  return await pb.collection('tipo').delete(id);
}
